import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { LoadingService } from 'src/app/services/loading/loading.service';


@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private loadingService: LoadingService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.loadingService.startHttpRequest(req);
    let size = 0;
    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          const contentLenght = event.headers.get('Content-Length') ?? '0';
          size = +contentLenght;

          // console.log('Content-Length header:', contentLength);
          // console.log('Calculated body size (bytes):', size);
        }
      }),
      finalize(() => this.loadingService.endHttpRequest(req, size))
    );
  }
}
